import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {ColumnBodyStyles, ColumnHeadStyles, Props} from './model';
import {useStyles} from '../../hooks/styles';
import {Text} from '../text';
import {LoadableContent} from '../loadableContent';

export default function Table<T extends Record<string, any>>({
  data,
  columns,
  isBordered = true,
  hideBottomLine: hideBootomLine,
  testIdPrefix,
  onRowClick,
}: Props<T>) {
  const styles = useStyles(({theme}) => ({
    row: {
      borderBottomWidth: isBordered ? 1 : 0,
      borderStyle: 'solid',
      borderColor: theme.color.borderColor,
      flexDirection: 'row',
    },
    colHead: {
      paddingTop: 4,
      paddingBottom: 4,
    },
    colBody: {
      paddingTop: 8,
      paddingBottom: 8,
      minHeight: 59,
      justifyContent: 'center',
    },
    colHeadText: {
      ...theme.fonts.body,
      color: theme.color.labelText,
    },
    colBodyText: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.labelText,
    },
  }));
  return (
    <View>
      <View style={[styles.row]}>
        {columns.map((column, i) => {
          const style: ColumnHeadStyles = column.headStyles ?? {};
          const {colHeadStyle = null, colHeadTextStyle = null} = style;
          return (
            <View style={[styles.colHead, colHeadStyle]} key={i}>
              <Text
                testID={column.titleTestID}
                numberOfLines={column.titleNumberOfLines}
                style={[styles.colHeadText, colHeadTextStyle]}>
                {column.title}
              </Text>
            </View>
          );
        })}
      </View>
      <LoadableContent loading={!data}>
        {data?.map((item, i) => {
          const testid = item.id && testIdPrefix ? {testID: `${testIdPrefix}-${item.id}`} : {};
          return (
            <View key={item.id ?? i} {...testid}>
              <TouchableOpacity onPress={() => onRowClick?.(item)} disabled={!onRowClick}>
                <View style={[styles.row, hideBootomLine && i === data.length - 1 && {borderBottomWidth: 0}]}>
                  {columns.map((column, j) => {
                    const style: ColumnBodyStyles =
                      typeof column.styles === 'function' ? column.styles(item) : column.styles ?? {};
                    const {colBodyStyle = null, colBodyTextStyle = null} = style;
                    return (
                      <View style={[styles.colBody, colBodyStyle]} key={j}>
                        {column.render ? (
                          column.render(item)
                        ) : (
                          <Text style={[styles.colBodyText, colBodyTextStyle]}>{item[column.field] ?? '–'}</Text>
                        )}
                      </View>
                    );
                  })}
                </View>
              </TouchableOpacity>
            </View>
          );
        })}
      </LoadableContent>
    </View>
  );
}
